// src/components/Wordmark.js
//
// Centralizes the "Hola" + accented "Sam" text markup that was previously
// hand-typed in four separate places (AppShell.js's header, TriagePage.js's
// and CalculatorPage.js's intro nav bars, and CalculatorResult.js's home
// link) — each one a manual copy of the same two-tone text, easy to drift
// (e.g. one missing the accent span, one with different casing).
//
// This component renders ONLY the text + accent span — not the surrounding
// box/container. There are two real visual treatments in the app today,
// and they're intentionally different, not a duplication to merge:
//   - Light/paper backgrounds (.triage-intro-wordmark, used in the
//     triage/calculator intro nav bars and the result-page home link):
//     the accent span needs the explicit `triage-start-wordmark__accent`
//     class, since that rule targets that class specifically.
//   - Dark backgrounds (AppShell's header, .u-wordmark-on-dark): the
//     accent color comes from a plain descendant selector
//     (`.u-wordmark-on-dark span`), so no class name is needed there —
//     just omit accentClassName.
//
// Callers keep full control of the wrapping element/class (div, Link,
// whatever container styling their context needs); this only removes the
// repeated inline text.

import React from 'react'

export default function Wordmark({ accentClassName }) {
  return (
    <>Hola<span className={accentClassName}>Sam</span></>
  )
}
